import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../../APIHelpers/Responses";

export const eiwrsUnblindingRequestTypeServices = {
  //Unblinding request Type
  addNewEIWRSUnblindingRequestType,
  updateEIWRSUnblindingRequestTypeData,
  deleteEIWRSUnblindingRequestTypeData,
  softDeleteRestoreEIWRSUnblindingRequestType,
  getEIWRSUnblindingRequestTypeData,
};

// Add New Unblinding request Type
async function addNewEIWRSUnblindingRequestType(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewEIWRSUnblindingRequestType`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Unblinding request Type
async function updateEIWRSUnblindingRequestTypeData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateEIWRSUnblindingRequestTypeData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Unblinding request Type
async function softDeleteRestoreEIWRSUnblindingRequestType(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreEIWRSUnblindingRequestType`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Unblinding request Type
async function deleteEIWRSUnblindingRequestTypeData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteEIWRSUnblindingRequestTypeData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Unblinding request Type
async function getEIWRSUnblindingRequestTypeData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSUnblindingRequestTypeData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSUnblindingRequestTypeData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}